/* eslint-disable jsx-a11y/heading-has-content */
/* eslint-disable no-loop-func */
import { useEffect, useLayoutEffect, useState } from "react";
import { allClasses } from "../../Store/api/activities";
import checkMark from "../../assets/images/checkmarks-calander.svg";
import polygon_arrow from "../../assets/images/Polygon-arrow.svg";
import {
  format,
  startOfWeek,
  addDays,
  isSameDay,
  lastDayOfWeek,
  isFirstDayOfMonth,
  isSunday,
  isPast,
} from "date-fns";
import { useDispatch, useSelector } from "react-redux";

const Calendars = ({ showDetailsHandle }) => {
  const [currentMonth, setCurrentMonth] = useState(new Date());
  const [hovered, setHovered] = useState(null);
  const [dueClasses, setDueClasses] = useState([]);
  const [isLoading, setIsloading] = useState(false);
  const dispach = useDispatch();
  let sevenDaysLater = new Date(new Date());
  sevenDaysLater.setDate(new Date().getDate() + 7);
  const renderHeader = () => {
    const dateFormat = "MMM yyyy";
    return (
      <h1 className="ft_16_calendar">
        <span>{format(currentMonth, dateFormat)}</span>
      </h1>
    );
  };
  /* ----------------------------------------- */
  // Assuming `res.data` contains the list of classes with activities
  const today = new Date().setHours(0, 0, 0, 0);

  // Initialize lists to collect all activities across dueClasses
  const categorizedActivities = {
    previousWithAnswers: [],
    previousWithoutAnswers: [],
    upcomingWithAnswers: [],
    upcomingWithoutAnswers: [],
  };

  dueClasses?.forEach((classes) => {
    classes.activities.forEach((activity) => {
      if (!activity.assignedDate) return; // Skip if there's no assigned date

      const assignedDate = new Date(activity.assignedDate).setHours(0, 0, 0, 0);
      const hasAnswers = activity.activityAnswers?.some(
        (activityAnswer) =>
          activityAnswer.answers.length > 0 &&
          activityAnswer.activityStatus === "Completed"
      );

      // Categorize activity based on date and answer status
      if (assignedDate < today) {
        if (hasAnswers) {
          categorizedActivities.previousWithAnswers.push(activity);
        } else {
          categorizedActivities.previousWithoutAnswers.push(activity);
        }
      } else if (assignedDate >= today) {
        if (hasAnswers) {
          categorizedActivities.upcomingWithAnswers.push(activity);
        } else {
          categorizedActivities.upcomingWithoutAnswers.push(activity);
        }
      }
    });
  });

  /* Calculate previous activity which is no answer */

  /* ................................ */
  useLayoutEffect(() => {
    setIsloading(true);
    dispach(
      allClasses({
        onSuccess: (res) => {
          setDueClasses(res.data);

          setIsloading(false);
        },
        onError: (err) => {
          setIsloading(false);
        },
      })
    );
  }, []);
  const renderDays = () => {
    const dayNames = ["Sun", "M", "Tu", "W", "Th", "F", "Sat"];
    const days = dayNames.map((dayName, index) => {
      // Define the desired text color for "Sun" and "Sat"
      const textColor =
        dayName === "Sun" || dayName === "Sat" ? "#76736F" : "#000";

      return (
        <li className="col col-center" key={index} style={{ color: textColor }}>
          {dayName}
        </li>
      );
    });

    return <ul className="list">{days}</ul>;
  };

  const getDueClassesForDay = (day) => {
    const formattedDate = format(day, "yyyy-MM-dd");
    return dueClasses.filter((course) =>
      course.activities.some(
        (activity) =>
          format(new Date(activity.assignedDate), "yyyy-MM-dd") ===
          formattedDate
      )
    );
  };
  const renderTooltip = (day) => {
    const formattedDate = format(day, "yyyy-MM-dd");
    const dueClassesForDay = getDueClassesForDay(day);
    const shortDays = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
    const shortDayName = shortDays[day.getDay()];
    return (
      <div>
        {dueClassesForDay.length > 0 && (
          <div
            className={`calendar_tooltip_box ${
              ["Sun", "Mon"].includes(shortDayName)
                ? "sun-tooltip"
                : ["Fri", "Sat"].includes(shortDayName)
                ? "fir-tooltip"
                : ["Tue", "Wed", "Thu"].includes(shortDayName)
                ? "tu-wed-thu"
                : ""
            }`}
          >
            <div className="calander-classes">
              <ul className="tooltip_text">
                {dueClassesForDay.map((course, index) => (
                  <div key={course.id}>
                    <span className="tooltip-span">{course.courseName}</span>
                    <div className="fw-400" style={{ display: "inline" }}>
                      {" "}
                      -{" "}
                      {
                        course.activities.filter(
                          (e) =>
                            format(new Date(e.assignedDate), "yyyy-MM-dd") ===
                            formattedDate
                        ).length
                      }{" "}
                      activities due
                    </div>
                  </div>
                ))}
              </ul>
            </div>
            <div
              className={`arrow-frame ${
                ["Sun", "Mon"].includes(shortDayName)
                  ? "sun-arrow"
                  : ["Fri", "Sat"].includes(shortDayName)
                  ? "fir-arrow"
                  : ""
              }`}
              style={{ position: "absolute", bottom: "-8px" }}
            >
              <img
                className="arrow_down"
                src={polygon_arrow}
                alt="polygon arrow"
              />
            </div>
          </div>
        )}
      </div>
    );
  };

  const renderCells = () => {
    const startDate = startOfWeek(currentMonth, { weekStartsOn: 0 });
    const endDate = lastDayOfWeek(currentMonth, { weekStartsOn: 0 });
    const dateFormat = "d";
    const rows = [];
    let days = [];
    let day = startDate;

    while (day <= endDate) {
      for (let i = 0; i < 21; i++) {
        const formattedDate = format(day, dateFormat);
        const cloneDay = day;
        const dueClassesForDay = getDueClassesForDay(day);
        // Completed activities on or after the current date
        const isAssignedToday = (activities, day) =>
          activities.some((activity) =>
            isSameDay(new Date(activity.assignedDate), day)
          );

        const isPreviousWithAnswers = isAssignedToday(
          categorizedActivities.previousWithAnswers,
          day
        );
        const isPreviousWithoutAnswers = isAssignedToday(
          categorizedActivities.previousWithoutAnswers,
          day
        );
        const isUpcomingWithAnswers = isAssignedToday(
          categorizedActivities.upcomingWithAnswers,
          day
        );
        const isUpcomingWithoutAnswers = isAssignedToday(
          categorizedActivities.upcomingWithoutAnswers,
          day
        );
        const isSundayOrFirstOfMonth = isSunday(day) || isFirstDayOfMonth(day);
        const isToday = isSameDay(day, new Date());
        const isTodayWithAnswers = isToday && isUpcomingWithAnswers;
        const isTodayWithoutAnswers = isToday && isUpcomingWithoutAnswers;

        // Determine the class based on conditions
        const dayCategoryClass = (function () {
          // Handle current date logic
          if (isToday) {
            if (isTodayWithAnswers) return "activity-completed-next";
            if (isTodayWithoutAnswers) return "next-atcivity";
            return "current-date"; // Applies if today has neither answers
          }

          // Handle previous activities
          if (!isSunday(day)) {
            if (isPreviousWithAnswers) return "activity-completed-previous";
            if (isPreviousWithoutAnswers) return "incomplete-previous";
          }

          // Handle upcoming activities
          if (!isSunday(day)) {
            if (isUpcomingWithAnswers) return "activity-completed-next";
            if (isUpcomingWithoutAnswers) return "next-atcivity";
          }

          // Handle Sunday or first of the month cases
          if (isSundayOrFirstOfMonth) {
            if (
              !isPreviousWithAnswers &&
              !isPreviousWithoutAnswers &&
              !isUpcomingWithoutAnswers &&
              !isUpcomingWithAnswers
            ) {
              return "sunday-formate";
            }
            if (isPreviousWithAnswers) {
              return "sunday-formate sunday-completed-previous";
            }
            if (isPreviousWithoutAnswers) {
              return "sunday-formate sunday-completed-previous ";
            }
            if (isUpcomingWithAnswers) {
              return "sunday-formate sunday-completed-next";
            }
            if (isUpcomingWithoutAnswers) {
              return "sunday-formate sunday-completed-next";
            }
            return "sunday-formate ";
          }

          return ""; // Default case
        })();

        days.push(
          <div
            className={`col cell  `}
            style={{
              position: "relative",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
            key={day}
            onMouseEnter={() => setHovered(Number(formattedDate))}
            onMouseLeave={() => setHovered(null)}
          >
            <p
              style={{
                position: "relative",
                fontSize: "14px",
              }}
              className={`days-formate ${dayCategoryClass} `}
            >
              {formattedDate}
            </p>
            {hovered === Number(formattedDate) && (
              <div>
                {dueClassesForDay.length > 0 &&
                  dueClassesForDay.map((dueClass) => (
                    <div key={dueClass.id}>{renderTooltip(cloneDay)}</div>
                  ))}
              </div>
            )}
          </div>
        );
        day = addDays(day, 1);
      }

      rows.push(
        <div className="row-calendar" style={{ marginLeft: "-2px" }} key={day}>
          {days}
        </div>
      );
      days = [];
    }

    return (
      <div className="body" style={{ marginLeft: "0px" }}>
        {rows}
      </div>
    );
  };

  return (
    <div className="calendar">
      {renderHeader()}
      <div className="custom_celander">
        {renderDays()}
        {renderCells()}
      </div>
    </div>
  );
};

export default Calendars;
